import {
  CommandBar,
  DetailsHeader,
  DetailsList,
  DetailsListLayoutMode,
  DetailsRow,
  IColumn,
  ICommandBarItemProps,
  IDetailsHeaderStyles,
  IDetailsListProps,
  IDetailsListStyles,
  IDetailsRowStyles,
  MarqueeSelection,
  SelectionMode,
  Stack,
} from "@fluentui/react";
import { CSSProperties, useEffect, useState } from "react";
import { IPagination } from "../../Interfaces/base/ITable";
import { _initialPagination } from "../../utils/helpers/helpers";
import COLORES from "../../utils/theme/colores";
import themeBase from "../../utils/theme/themeBase";
import { LineProgress } from "../indicadores/Load";
import { PaginationFooterB } from "../PaginationFooter/PaginationFooterB";

const _rigthBar: ICommandBarItemProps[] = [];
const _leftBar: ICommandBarItemProps[] = [];
let _data: any[] = [];
let _column: IColumn[]=[];
const _style: CSSProperties = {};
let _pagination: IPagination = _initialPagination();
let _selection: any = {};

export const TableBase = ({
  rigthBar = _rigthBar,
  leftBar = _leftBar,
  data = _data,
  column = _column,
  style = _style,
  isLoading = true,
  layout = DetailsListLayoutMode.fixedColumns,
  pagination = _pagination,
  selection = _selection,
  getPageSize,
}) => {
  const [tableHeight, setTableHeight] = useState("50vh");

  const updateTableHeight = () => {
    const windowHeight = window.innerHeight;
    const newTableHeight = `${windowHeight * 0.8}px`;
    setTableHeight(newTableHeight);
  };

  useEffect(() => {
    updateTableHeight();
    window.addEventListener("resize", updateTableHeight);
    return () => {
      window.removeEventListener("resize", updateTableHeight);
    };
  }, []);

  const _onRenderHeader: Partial<IDetailsListStyles> = {
    root: {
      overflowX: "scroll",
      selectors: {
        "& [role=grid]": {
          display: "flex",
          flexDirection: "column",
          alignItems: "start",
          height: tableHeight,
        },
      },
    },
    headerWrapper: {
      margin: "0 0 1px 0",
      paddingTop: "0px",
      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)", // Cambia esto según tus necesidades
      flex: "0 0 auto",
    },
    contentWrapper: {
      flex: "1 1 auto",
      overflowY: "auto",
      overflowX: "hidden",
    },
  };

  return (
    <>
      <div style={style}>
        {(rigthBar.length > 0 || leftBar.length > 0) && (
          <div className="ms-Grid-col ms-sm12 ms-lg12">
            <CommandBar
              items={leftBar}
              farItems={rigthBar}
              styles={themeBase.commadStyles}
            />
          </div>
        )}
        <Stack>
          <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
            <LineProgress disabled={!isLoading} />
            {!isLoading && (
              <>
                {!isObjectEmpty(selection) ? (
                  <>
                    {/* Table selection multiple */}
                    <MarqueeSelection selection={selection}>
                      <DetailsList
                        items={data}
                        compact={true}
                        columns={column}
                        selectionMode={SelectionMode.multiple}
                        setKey="multiple"
                        layoutMode={layout}
                        isHeaderVisible={true}
                        selection={selection}
                        selectionPreservedOnEmptyClick={true}
                        enterModalSelectionOnTouch={true}
                        ariaLabelForSelectionColumn="Toggle selection"
                        ariaLabelForSelectAllCheckbox="Toggle selection for all items"
                        checkButtonAriaLabel="select row"
                        styles={_onRenderHeader}
                        onRenderRow={_onRenderRow}
                        onRenderDetailsHeader={_onRenderDetailsHeader}
                      />
                    </MarqueeSelection>
                  </>
                ) : (
                  <>
                    {/* Table normal */}
                    <DetailsList
                      items={data}
                      compact={true}
                      columns={column}
                      selectionMode={SelectionMode.none}
                      setKey="set"
                      layoutMode={layout}
                      isHeaderVisible={true}
                      selectionPreservedOnEmptyClick={true}
                      enterModalSelectionOnTouch={true}
                      ariaLabelForSelectionColumn="Toggle selection"
                      ariaLabelForSelectAllCheckbox="Toggle selection for all items"
                      checkButtonAriaLabel="select row"
                      styles={_onRenderHeader}
                      onRenderRow={_onRenderRow}
                      onRenderDetailsHeader={_onRenderDetailsHeader}
                    />
                  </>
                )}
              </>
            )}
            <div
              style={{
                position: "fixed",
                width: "calc(100% - 235px)",
                bottom: 0,
              }}
            >
              <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                <PaginationFooterB
                  valueChangeSize={(value: number) => getPageSize(value)}
                  total={data.length}
                  pagination={pagination}
                />
              </div>
            </div>
          </div>
        </Stack>
      </div>
    </>
  );
};

/* Validate Object */
const isObjectEmpty = (obj) => {
  return Object.keys(obj).length === 0;
};

const _onRenderDetailsHeader: IDetailsListProps["onRenderDetailsHeader"] = (
  props
) => {
  const customStyles: Partial<IDetailsHeaderStyles> = {};
  customStyles.root = {
    // padding: '.25rem 0 .25rem 0',
    // paddingTop: 0,
    // textAlign: "center",
    // height: "1.5rem",
    // lineHeight: "none",
    paddingTop: "0px",
    textAlign: "",
  };
  if (props) {
    return <DetailsHeader {...props} styles={customStyles} />;
  }
  return null;
};

const _onRenderRow: IDetailsListProps["onRenderRow"] = (props) => {
  const customStyles: Partial<IDetailsRowStyles> = {};
  if (props) {
    customStyles.root = {
      width: "100%",
      margin: "0 0 0 0",
      // margin: '5px 0 5px 0',
      // borderRadius: '5px',
      // padding: '0.1rem 0 0.1rem 0',
      // border: themeBase.theme.effects.elevation4,
      // fontSize: '0.68rem',
      // minHeight:'2.62rem'
    };
    // customStyles.fields = {
    //     // textAlign: "start",
    //     // alignItems: "center",
    //     // padding: '0.1rem 0 0.1rem 0',
    // }
    return <DetailsRow {...props} styles={customStyles} />;
  }
  return null;
};
